export enum FileExtensionEnum {
  Malloy = '.malloy',
  Schema = '.schema',
  Store = '.store',
  Chart = '.chart',
  Report = '.report',
  Dashboard = '.dashboard',
  Space = '.space',
  Yml = '.yml',
  Md = '.md'
}
